export function canUserAccessContabilidad(user) {
  if (!user) return false;
  if (user.is_super_admin) return true;
  if (user.role === 'contador') return true;
  return Boolean(user.access_contabilidad);
}

export function canSuperAdminAssignContabilidadAccess(user) {
  if (!user) return false;
  if (user.is_super_admin) return false;
  if (user.role === 'contador') return false;
  return true;
}
